// Port of api/fuel/app/classes/filter/search/games/rules/query/inventory_location.php
import Rule from 'offline/filter/core/search/rule'
import DB from 'offline/db'
import Util from 'offline/util'

function textInIndex(values) {
	var index = []
	for (var i = 0; i < values.length; i++) {
		var value = String(values[i]).toLowerCase().replace(/'/g, "''")
		index.push("'" + value + "'")
		index.push("'" + value.replace(/-/g, ' ') + "'")
	}
	return index.join(',')
}

export default Rule.create({
	name: 'inventory_location',
	isIndex: function() { return true },
	field: function() { return 'c.collection_id' },
	require: function(config, filter) {
		if (!config || !config.can || !config.can['view.inventory.location']) return false
		if (!filter.rules || !filter.rules.length) return false
		for (var i = 0; i < filter.rules.length; i++) {
			if (filter.rules[i].type && filter.rules[i].type.replace(/\./g, '_') === 'inventory_location') return true
		}
		return false
	},
	oneof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('c.collection_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT collection_id FROM collection WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(collection_private_location) IN(' + textInIndex(values) + ')'
		), 'collection_id')

		var result = Rule.setFilter(rule, 'one', ids)
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where('c.collection_id', opMap, result)
	},
	someof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('c.collection_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT collection_id FROM collection WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(collection_private_location) IN(' + textInIndex(values) + ')'
		), 'collection_id')

		query.where('c.collection_id', 'in', Rule.setFilter(rule, 'some', ids))
	},
	allof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('c.collection_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT collection_id FROM collection WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(collection_private_location) IN(' + textInIndex(values) + ')'
		), 'collection_id')

		query.where('c.collection_id', 'in', Rule.setFilter(rule, 'all', ids))
	},
	match: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('c.collection_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT collection_id FROM collection WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(collection_private_location) IN(' + textInIndex(values) + ')'
		), 'collection_id')

		var result = Rule.setFilter(rule, 'one', ids)
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where('c.collection_id', opMap, result)
	}
})
